export const OrganizationPermissions_DbKey = 'organization-permissions';
//# sourceMappingURL=types.js.map